export const ROLE_USER: "ROLE_USER" = "ROLE_USER";
export const ROLE_APPLICATION_DEV_ADMIN_PORTAL_TECH: "ROLE_APPLICATION_DEV_ADMIN_PORTAL_TECH" =
  "ROLE_APPLICATION_DEV_ADMIN_PORTAL_TECH";
export const ROLE_MERCHANT_PORTAL_ADMIN_TECH: "ROLE_MERCHANT_PORTAL_ADMIN_TECH" =
  "ROLE_MERCHANT_PORTAL_ADMIN_TECH";
export const ROLE_MERCHANT_PORTAL_ADMIN_FINANCE: "ROLE_MERCHANT_PORTAL_ADMIN_FINANCE" =
  "ROLE_MERCHANT_PORTAL_ADMIN_FINANCE";
export const ROLE_PSP_PORTAL_ADMIN_TECH: "ROLE_PSP_PORTAL_ADMIN_TECH" =
  "ROLE_PSP_PORTAL_ADMIN_TECH";
export const ROLE_PSP_PORTAL_ADMIN_FINANCE: "ROLE_PSP_PORTAL_ADMIN_FINANCE" =
  "ROLE_PSP_PORTAL_ADMIN_FINANCE";
export const ROLE_PSP_PORTAL: "ROLE_PSP_PORTAL" = "ROLE_PSP_PORTAL";
export const ROLE_PSP_MERCHANT_PORTAL: "ROLE_PSP_MERCHANT_PORTAL" =
  "ROLE_PSP_MERCHANT_PORTAL";
export const ROLE_VOLT_PORTAL_ADMIN: "ROLE_VOLT_PORTAL_ADMIN" =
  "ROLE_VOLT_PORTAL_ADMIN";
export const ROLE_VOLT_PORTAL_SUPPORT: "ROLE_VOLT_PORTAL_SUPPORT" =
  "ROLE_VOLT_PORTAL_SUPPORT";
export const ROLE_MERCHANT_PORTAL: "ROLE_MERCHANT_PORTAL" =
  "ROLE_MERCHANT_PORTAL";
export const ROLE_VOLT_PORTAL_STANDARD: "ROLE_VOLT_PORTAL_STANDARD" =
  "ROLE_VOLT_PORTAL_STANDARD";
